import {Component} from 'react'
import Cookies from 'js-cookie'
import {BsSearch} from 'react-icons/bs'
import Loader from 'react-loader-spinner'

import JobItem from '../JobItem'
import Header from '../Header'
import ProfileSection from '../ProfileSection'
import FilterGroup from '../FilterGroup'

import './index.css'

const employmentTypesList = [
  {
    label: 'Full Time',
    employmentTypeId: 'FULLTIME',
  },
  {
    label: 'Part Time',
    employmentTypeId: 'PARTTIME',
  },
  {
    label: 'Freelance',
    employmentTypeId: 'FREELANCE',
  },
  {
    label: 'Internship',
    employmentTypeId: 'INTERNSHIP',
  },
]

const salaryRangesList = [
  {
    salaryRangeId: '1000000',
    label: '10 LPA and above',
  },
  {
    salaryRangeId: '2000000',
    label: '20 LPA and above',
  },
  {
    salaryRangeId: '3000000',
    label: '30 LPA and above',
  },
  {
    salaryRangeId: '4000000',
    label: '40 LPA and above',
  },
]

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  inProgress: 'IN_PROGRESS',
  failure: 'FAILURE',
}

class Jobs extends Component {
  state = {
    searchInput: '',
    jobsList: [],
    apiStatus: apiStatusConstants.initial,
    activeCheckboxList: [],
    activeSalaryId: '',
  }

  componentDidMount() {
    this.getJobsList()
  }

  getJobsList = async () => {
    this.setState({apiStatus: apiStatusConstants.inProgress})
    const {searchInput, activeCheckboxList, activeSalaryId} = this.state

    const activeEmploymentId = activeCheckboxList.join(',')

    const jwtToken = Cookies.get('jwt_token')
    const apiUrl = `https://apis.ccbp.in/jobs?employment_type=${activeEmploymentId}&minimum_package=${activeSalaryId}&search=${searchInput}`
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const response = await fetch(apiUrl, options)
    const data = await response.json()

    if (response.ok) {
      const updatedData = data.jobs.map(eachJob => ({
        companyLogoUrl: eachJob.company_logo_url,
        employmentType: eachJob.employment_type,
        id: eachJob.id,
        jobDescription: eachJob.job_description,
        location: eachJob.location,
        packagePerAnnum: eachJob.package_per_annum,
        rating: eachJob.rating,
        title: eachJob.title,
      }))
      this.setState({
        jobsList: updatedData,
        apiStatus: apiStatusConstants.success,
      })
    } else {
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  handleSearchInput = event => {
    this.setState({searchInput: event.target.value})
  }

  onClickSearchBtn = () => {
    this.getJobsList()
  }

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.getJobsList()
    }
  }

  renderAllJobsView = () => {
    const {jobsList, searchInput} = this.state
    const jobsListLength = jobsList.length <= 0
    return (
      <div className="jobs-section-container">
        <div className="input-container">
          <input
            type="search"
            placeholder="Search"
            className="search-input"
            value={searchInput}
            onChange={this.handleSearchInput}
            onKeyDown={this.onKeyPress}
          />
          <button
            type="button"
            data-testid="searchButton"
            onClick={this.onClickSearchBtn}
            className="search-btn"
          >
            <BsSearch className="search-icon" />
          </button>
        </div>
        {jobsListLength ? (
          <div className="failure-container">
            <img
              src="https://assets.ccbp.in/frontend/react-js/no-jobs-img.png"
              alt="no jobs"
              className="no-job-img"
            />
            <h1 className="failure-heading">No Jobs Found</h1>
            <p className="failure-para">
              We could not find any jobs. Try other filters
            </p>
          </div>
        ) : (
          <>
            <ul />
            <ul />
            <ul className="jobs-container">
              {jobsList.map(eachJob => (
                <JobItem jobDetails={eachJob} key={eachJob.id} />
              ))}
            </ul>
          </>
        )}
      </div>
    )
  }

  renderLoadingView = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  onClickRetryBtn = () => {
    this.getJobsList()
  }

  renderFailureView = () => (
    <div className="failure-container">
      <img
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
        alt="failure-view"
        className="failure-img"
      />
      <h1 className="failure-heading">Oops! Something Went Wrong</h1>
      <p className="failure-para">
        We cannot seem to find the page you are looking for.
      </p>
      <button
        type="button"
        className="retry-btn"
        onClick={this.onClickRetryBtn}
      >
        Retry
      </button>
    </div>
  )

  renderJobsList = () => {
    const {apiStatus} = this.state
    switch (apiStatus) {
      case apiStatusConstants.success:
        return this.renderAllJobsView()
      case apiStatusConstants.inProgress:
        return this.renderLoadingView()
      case apiStatusConstants.failure:
        return this.renderFailureView()
      default:
        return null
    }
  }

  setEmploymentType = (isChecked, employmentTypeId) => {
    const {activeCheckboxList} = this.state
    let updateActiveCheckboxList
    if (isChecked) {
      updateActiveCheckboxList = [...activeCheckboxList, employmentTypeId]
    } else {
      updateActiveCheckboxList = activeCheckboxList.filter(
        id => id !== employmentTypeId,
      )
    }
    this.setState(
      {activeCheckboxList: updateActiveCheckboxList},
      this.getJobsList,
    )
  }

  onChangeUpdateSalaryRange = salaryId => {
    this.setState({activeSalaryId: salaryId}, this.getJobsList)
  }

  render() {
    const {activeCheckboxList} = this.state
    return (
      <div className="bg-container">
        <Header />
        <div className="filter-and-jobs-container">
          <div className="profile-and-filter-container">
            <ProfileSection />
            <FilterGroup
              activeCheckboxList={activeCheckboxList}
              employmentTypesList={employmentTypesList}
              setEmploymentType={this.setEmploymentType}
              salaryRangesList={salaryRangesList}
              onChangeUpdateSalaryRange={this.onChangeUpdateSalaryRange}
            />
          </div>
          {this.renderJobsList()}
        </div>
      </div>
    )
  }
}

export default Jobs
